import DisplayPublicPageRowAction, { DisplayPublicPageRowActionProps } from './DisplayPublicPageRowAction';

export function GoPublicPageRowAction(props: GoPublicPageRowActionProps) {
    return <DisplayPublicPageRowAction {...props} />;
}

export type GoPublicPageRowActionProps = DisplayPublicPageRowActionProps;

// noinspection JSUnusedGlobalSymbols
export default GoPublicPageRowAction;
